import React from 'react';
export const BrowserFeatureContext = React.createContext({
    supportsWebp: false,
    supportsLazy: false
});
BrowserFeatureContext.displayName = 'BrowserFeatureContext';
